export function isSet(value) {
    return value != null && value !== '';
}
//# sourceMappingURL=is-set.js.map